<div class="uredjaji-page">

    <div class="uredjaji-page__container">
        <uredjaji-tablica [uredjaji]="uredjaji"></uredjaji-tablica>
    </div>

</div>
